module.exports = new __parcel__URL__("battleroyale_neon_gold_icon.12ac7a86.png").toString();